const NAME_REGEXP = /^[A-Za-z0-9-_|.]{1,30}$/;

export default NAME_REGEXP;